import React, { useEffect, useMemo, useState } from "react";
import CalendarLayout from "../../Layout/CalendarLayout/CalendarLayout";
import { useRequestProcessor } from "../../requestProcessor";
import { useAtom } from "jotai";
import { activeChildDetail, FoodAtom } from "../../AtomStore/store";
import moment from "moment";
import { fetchFood } from "../../QueryFunctions/queryfunction";
import SpinnerLoading from "../../Components/utils/SpinnerLoading";
import plate from "../../assets/foodMenu/plate.png";

const FoodMenuMobile = () => {
  const { useQueryWrapper } = useRequestProcessor();
  const SERVER_DATE_FORMAT = "YYYY-MM-DD";

  const [activeChild] = useAtom(activeChildDetail);
  const [food, setFood] = useAtom(FoodAtom);
  const [selectedDate, setSelectedDate] = useState(
    moment().format(SERVER_DATE_FORMAT)
  );
  const [error, setError] = useState(null);

  useMemo(() => {
    console.log(
      `[Food Menu] Fetching Food Menu details for user: ${activeChild?.id}`
    );
  }, [activeChild]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const { isFetching } = useQueryWrapper(
    ["food", activeChild?.id, selectedDate],
    () => fetchFood(selectedDate),
    {
      onSuccess: (data) => {
        if (data?.lunch || data?.breakfast || data?.snacks || data?.fruits) {
          setFood(data);
          setError(null);
        } else {
          setError(data);
        }
      },
      onError: (err) => {
        setError("Failed to fetch the food menu. Please try again later.");
      },
    }
  );
  console.log("selected Date", selectedDate);
  return (
    <CalendarLayout
      setSelectedDate={setSelectedDate}
      selectedDate={selectedDate}
    >
      {isFetching ? <SpinnerLoading /> : ""}
      {error ? (
        <div className="flex flex-col justify-center items-center h-[30vh] ">
          <img src={plate} alt="oops"></img>
          <p className="text-lg font-base text-gray-500 text-center">{error}</p>
        </div>
      ) : (
        food &&
        Object.keys(food).length > 0 && (
          <div className="grid grid-cols-12 gap-2 ">
            <div className=" grid grid-cols-12 col-span-12 md:col-span-6  rounded-lg min-h-36 p-4 bg-[#2bce89]">
              <div className="col-span-8">
                <p className=" text-2xl font-bold items-start justify-start text-white ">
                  {/* <img src={sunrise} alt="sunrise" className="w-7 h-7" /> */}
                  Breakfast
                </p>
                <h3 className="font-medium text-white text-lg">
                  {food?.breakfast}
                </h3>
              </div>

              <div className="flex justify-end items-end col-span-4">
                <img
                  alt="breakfast"
                  src="https://img.icons8.com/?size=700&id=26093&format=png&color=000000"
                  className="w-[70px] h-[70px] object-contain"
                />
              </div>
            </div>

            <div className="col-span-12 md:col-span-6 grid grid-cols-12 flex flex-col rounded-lg  min-h-36 p-4 bg-[#fb6340]">
              <div className="col-span-8">
                <p className=" text-2xl font-bold items-start justify-start text-white">
                  {/* <img src={sunrise} alt="sunrise" className="w-7 h-7" /> */}
                  Lunch
                </p>
                <h3 className="font-medium text-white text-lg">
                  {food?.lunch}
                </h3>
              </div>

              <div className="flex justify-end items-end col-span-4">
                <img
                  alt="lunch"
                  src="https://img.icons8.com/?size=700&id=Lc1bOGTPnex7&format=png&color=000000"
                  className="w-[70px] h-[70px] object-contain"
                />
              </div>
            </div>

            <div className=" grid grid-cols-12 col-span-12 md:col-span-6  rounded-lg min-h-36 p-4 bg-[#f5365b]">
              <div className="col-span-8">
                <p className=" text-2xl font-bold items-start justify-start text-white">
                  {/* <img src={sunrise} alt="sunrise" className="w-7 h-7" /> */}
                  Fruits
                </p>
                <h3 className="font-medium text-white text-lg">
                  {food?.fruits}
                </h3>
              </div>

              <div className="flex justify-end items-end col-span-4">
                <img
                  alt="breakfast"
                  src="https://img.icons8.com/?size=700&id=AmGF1k4J8fD7&format=png&color=000000"
                  className="w-[70px] h-[70px] object-contain"
                />
              </div>
            </div>
            <div className=" grid grid-cols-12 col-span-12 md:col-span-6  rounded-lg min-h-36 p-4 bg-[#0ccdef]">
              <div className="col-span-8">
                <p className=" text-2xl font-bold items-start justify-start text-white">
                  {/* <img src={sunrise} alt="sunrise" className="w-7 h-7" /> */}
                  Snacks
                </p>
                <h3 className="font-medium text-white text-lg">
                  {food?.snacks}
                </h3>
              </div>

              <div className="flex justify-end items-end col-span-4">
                <img
                  alt="breakfast"
                  src="https://img.icons8.com/?size=700&id=0qvlgj75WlUP&format=png&color=000000"
                  className="w-[70px] h-[70px] object-contain"
                />
              </div>
            </div>

            {/* <div className="col-span-6 rounded-lg min-h-36 p-2 flex flex-col justify-between">
              <p className="flex text-xl font-bold items-start justify-center">
                <img src={Sunset} alt="snacks" className="w-7 h-7" />
                &nbsp; Snacks
              </p>
              <div className="flex justify-center">
                <img
                  alt="snacks"
                  src="https://img.icons8.com/?size=40&id=0qvlgj75WlUP&format=png&color=000000"
                />
              </div>
              <h3 className="font-light text-center text-sm">{food?.snacks}</h3>
            </div> */}
          </div>
        )
      )}
    </CalendarLayout>
  );
};

export default FoodMenuMobile;
